import React from "react";
import { Reorder } from 'framer-motion';
import { matchPhrases } from "../../../utils/utilities";

import AccordionItem from "../custom-visual-inspection/accordion-item";
import CustomNewItem from '../custom-general/custom-new-item';
import InfraredEquipmentForm, { InfraredEquipment } from "../../forms/custom-infrared/infraredEquipmentForm";
import ItemCount from '../../blocks/item-count';
import ReorderItem from '../../common/reorderItem';

import toastService from "../../../services/toastService";

interface Props {
    infraredEquipmentItems: InfraredEquipment[];
    onChangeInfraredEquipmentItems: (items: InfraredEquipment[]) => void;
}

const InfraredEquipmentItems: React.FC<Props> = ({ infraredEquipmentItems, onChangeInfraredEquipmentItems }) => {
    const handleAddItem = (item: InfraredEquipment) => {
        const itemMatch = infraredEquipmentItems.find((analysisItem) => matchPhrases(analysisItem.equipmentName, item.equipmentName));
        if (itemMatch) return toastService.error(`Equipment ${item.equipmentName} already exists!`);

        const newAnalysisItems = [...infraredEquipmentItems, item];
        onChangeInfraredEquipmentItems(newAnalysisItems);
    };

    const handleDeleteItem = (item: InfraredEquipment) => {
        const newAnalysisItems = infraredEquipmentItems.filter((analysis) => analysis.equipmentName !== item.equipmentName);
        onChangeInfraredEquipmentItems(newAnalysisItems);
    };
   
    const handleEditItem = (baseItem: InfraredEquipment, updatedItem: InfraredEquipment) => {
        const newAnalysisItems = infraredEquipmentItems.map((analysis) => analysis.equipmentName === baseItem.equipmentName ? updatedItem : analysis);
        onChangeInfraredEquipmentItems(newAnalysisItems);
    };

    return ( 
        <>
            <ItemCount count={infraredEquipmentItems.length} label='Infrared Equipment' />
                            
            <CustomNewItem label='Add New Infrared Equipment'>
                <InfraredEquipmentForm onSave={handleAddItem} />
            </CustomNewItem>
            
            <Reorder.Group className="list-unstyled" values={infraredEquipmentItems} onReorder={onChangeInfraredEquipmentItems}>
                {infraredEquipmentItems.map((item) => (
                    <ReorderItem key={item.equipmentName} value={item}>
                        <AccordionItem title={item.equipmentName} isActive>
                            <InfraredEquipmentForm
                                initialInfraredData={item}
                                onSave={(updated: InfraredEquipment) => handleEditItem(item, updated)}
                                onDeleteItem={() => handleDeleteItem(item)}
                            />
                        </AccordionItem>
                    </ReorderItem>
                ))}
            </Reorder.Group>
        </>
     );
};
 
export default InfraredEquipmentItems;